import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Button,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core'
import Icon from '@mdi/react'
import {
  mdiAlertCircleOutline,
  mdiBarcodeScan,
  mdiFilePdfBox,
} from '@mdi/js'
import copy from 'copy-to-clipboard'

import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { SNACKBAR } from '../../main/MainActions'
import colors from '../../../assets/colors'

import StatusChip, { getInvoiceStatusTone } from './Forms/StatusChip'

const useStyles = makeStyles({
  title: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    justifyContent: 'space-between',
    gap: '8px',
    fontSize: '20px',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 0',
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  label: {
    fontSize: '13px',
    color: colors.textPrimary,
  },
  value: {
    fontSize: '13px',
    fontWeight: 700,
    color: colors.textCustom,
  },
  actions: {
    display: 'flex',
    gap: '8px',
    marginTop: '16px',
  },
  action: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    borderRadius: '16px',
    border: `1px solid ${colors.graylight}`,
    color: colors.primary,
    fontSize: '13px',
    fontWeight: 700,
    textTransform: 'none',
    padding: '8px 12px',
  },
})

const InvoiceDetails = ({ open, handleClose }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const invoice = useSelector(state => state.subscription.showInvoice)

  const hanldePdf = url => {
    window.open(url, '_blank')
  }

  const handleCopy = async value => {
    try {
      await copy(value)

      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: { message: 'Código copiado com sucesso!' },
      })
    } catch (error) {
      return dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Erro ao copiar o codigo!' },
      })
    }
  }

  return (
    <BaseFilterModal
      open={open}
      hiddenHelpButton
      handleOpen={handleClose}
      title="Detalhes da Fatura"
    >
      <Grid item xs={12} style={{ width: '350px' }}>
        <Box className={classes.title}>
          <Typography
            variant="h4"
            style={{ fontSize: '24px', fontWeight: 'bold' }}
            color={colors.primary}
          >
            R$ {invoice?.value}
          </Typography>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <StatusChip
              label={invoice?.status_value}
              tone={getInvoiceStatusTone(
                invoice?.status_id,
                invoice?.status_value
              )}
            />
            {invoice?.status_id == 40 && (
              <Tooltip
                title={
                  invoice?.failure_reason ||
                  'Motivo não informado pelo gateway'
                }
              >
                <span style={{ display: 'flex' }}>
                  <Icon
                    path={mdiAlertCircleOutline}
                    size={0.75}
                    color={colors.error}
                  />
                </span>
              </Tooltip>
            )}
          </Box>
        </Box>

        <Box>
          <Box className={classes.row}>
            <Typography className={classes.label}>Vencimento</Typography>
            <Typography className={classes.value}>
              {invoice?.vencimento}
            </Typography>
          </Box>

          <Box className={classes.row} style={{ borderBottom: 'none' }}>
            <Typography className={classes.label}>Plano</Typography>
            <Typography className={classes.value}>
              {invoice?.pagarme_plan}
            </Typography>
          </Box>
        </Box>

        <Grid item xs={12}>
          <Box className={classes.actions}>
            <Button
              onClick={() => hanldePdf(invoice?.pdf)}
              className={classes.action}
            >
              <Icon path={mdiFilePdfBox} size={0.85} />
              Baixar PDF
            </Button>
            <Button
              onClick={() => {
                handleCopy(invoice?.codigo)
              }}
              className={classes.action}
            >
              <Icon path={mdiBarcodeScan} size={0.85} />
              Copiar código
            </Button>
          </Box>
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default InvoiceDetails
